import { useFilterNotificationStore } from "presentation/stores/use-filter-notification-store";
import { Button } from "primereact/button";
import { useState } from "react";

const HeaderNotificationGrid: React.FC = () => {
  const [globalFilterValue, setGlobalFilterValue] = useState<string>("");
  const { filters, setFilters, resetFilters } = useFilterNotificationStore();

  const clearFilter = () => {
    resetFilters();
    setGlobalFilterValue("");
    setFilters({
      query: { value: "", matchMode: "contains" },
      object: { value: "", matchMode: "contains" },
      name: { value: "", matchMode: "contains" },
      subject: { value: "", matchMode: "contains" },
    });
  };

  return (
    <div className="flex justify-content-between">
      <div></div>
      <div style={{ display: "flex" }}>
        <div style={{ width: "10px" }}></div>
        <Button
          type="button"
          icon="pi pi-filter-slash"
          label="Limpar"
          outlined
          onClick={clearFilter}
          style={{
            backgroundColor: "white",
            borderColor: "#2196f3",
            color: "#2196f3",
            borderRadius: "8px",
          }}
        />
      </div>
    </div>
  );
};
export default HeaderNotificationGrid;
